export class FamilyProjectArchiveBaseModel {
    familyProjectArchiveId: string;
    familyProjectId:string;
    type: string;
    action: number;
    fileName: string;
    projectLog: string;
    updatedDate: Date;
    status: number;
}